import "../../vendors/cookieconsent.js";
import CookieConsent from "./cookieconsent.js";

export const CC = new CookieConsent();

export default { CC };
